// import { ErrorMessage } from "@hookform/error-message";
import { Fragment } from "react";
import {
  Autocomplete,
  Box,
  FormHelperText,
  Grid,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import Typography from "@mui/material/Typography";
// import Tooltip from "@mui/material/Tooltip";
// import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import TextQuestionComponent from "./TextQuestionComponent";
import { useEffect, useState } from "react";
import ConditionalQuestions from "./ConditionalQuestions";
import TooltipComponent from "../../common/Tooltip";
import { useTheme } from "@mui/material/styles";

function SelectQuestionComponent({ question, questionsObject }) {
  const {
    control,
    getValues,
    setValue,
    unregister,
    formState: { errors },
  } = useFormContext();
  const isMobile = useMediaQuery("(max-width:600px)");

  const [fieldIsConditional, setFieldIsConditional] = useState(false);
  const [callUseEffect, setCallUseEffect] = useState(false);

  useEffect(() => {
    question?.conditional?.map((conditionalField, i) => {
      questionsObject?.map((conditionalQuestion, i) => {
        if (
          conditionalQuestion.questionId === conditionalField.questionId &&
          getValues(question.questionName) === "Other"
        ) {
          setFieldIsConditional(true);
        } else if (
          conditionalQuestion.questionId === conditionalField.questionId &&
          getValues(question.questionName) !== "Other"
        ) {
          unregister(conditionalQuestion.questionName);
          // setValue(conditionalQuestion.questionName, "");
        }
      });
    });
  }, [callUseEffect]);

  const handleConditionalQuestion = () => {
    callUseEffect ? setCallUseEffect(false) : setCallUseEffect(true);
    setFieldIsConditional(false);
  };
  const theme = useTheme();

  return (
    <>
      <Grid
        item
        xs={question?.isSuggested ? 12 : 12}
        sx={{
          mb: 2,
          ml: question?.isSuggested ? 2 : 0,
          backgroundColor: question?.isSuggested
            ? theme.palette.primary.nestedQuestionBackground
            : "",
          py: question?.isSuggested ? 2 : 0,
          px: question?.isSuggested ? 1.5 : 0,
          borderRadius: question?.isSuggested ? 2 : 0,
          border: question?.isSuggested ? "1px solid #fff" : "none",
          boxShadow: question?.isSuggested
            ? "0px 2px 4px rgba(0, 0, 0, 0.2)"
            : 0,
          cursor: question?.isSuggested ? "pointer" : "",
        }}
      >
        <Typography
          // variant="h6"
          // component="h1"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{ fontWeight: "600", mb: 0.5, fontSize: "14px", color: "text.primary" }}
          className="stepper-question"
        >
          <Box>
            {question.label}
            {question.rules.required && (
              <>
                &nbsp;<span style={{ color: "red" }}>*</span>
              </>
            )}
          </Box>

          {question.question_info != null &&
          question.question_info.replace(/\s/g, "")?.length != 0 ? (
            <>
              <TooltipComponent message={question?.question_info} />
            </>
          ) : (
            <></>
          )}
        </Typography>
        <Controller
          name={question.questionName}
          control={control}
          rules={question.rules}
          render={({ field }) => (
            <Autocomplete
              {...field}
              // size="small"
                          size={isMobile?'small':'medium'}

              onChange={(event, newValue) => {
                field.onChange(newValue);
                newValue === "Other"
                  ? setFieldIsConditional(true)
                  : handleConditionalQuestion();
              }}
              id="size-small-standard"
              options={question.options}
              getOptionLabel={(option) => option || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  autoFocus={question?.autoFocus}
                  // size="small"
                  variant="outlined"
                  label={question.placeholder}
                />
              )}
            />
          )}
        />
        {errors[question.questionName]?.type === "required" && (
          // <p className={"errorMsg"}>{question.errorMsg}</p>
          <FormHelperText error className={"errorMsg"}>
            {question.errorMsg}
          </FormHelperText>
        )}
      </Grid>
      {fieldIsConditional && (
        <ConditionalQuestions
          question={question}
          questionsObject={questionsObject}
        />
      )}
    </>
  );
}
export default SelectQuestionComponent;
